import {Component} from 'react';
import {RadioBox} from './radiobox';
import {FormError} from './form-errors';
import {MontantInput} from './montant-input';
import {MontantsDetailles} from './details-montant-input';
import InfoBulle from './info.js';

class Questionnaire extends Component {
	constructor(props){
		super(props);
		this.state = {
			steps : 8 ,
			step : 1 ,
			hasPensionAlimentaire :false,
			pensionAlimentaire : {
				value:{},
				
			},
			pensionDetails:false,
			permisDeConduire :false,
			difficulte:false,
			achatLogement:false,
			travaux:false,
			changementLogementRecent:false,
			lieuxSolidaire:false,
			creationEntreprise:false,
			aideAchatVelo:false,
			errors : [],
			rfr : 0 , 
		};

		/* Initialisation pension alimentaire */
    	
    	this.state.pensionAlimentaire.value = '';
    	/*aides velo */

    	this.state.veloPrice = 0;
    	this.state.veloType = false;


	}
	

	updateVeloPrice = (event) => {
		this.setState({veloPrice : event.target.value});
	}

	updateVeloType = (event) => {
		this.setState({veloType : event.target.value});
	}
	updateRFR = (event) => {
        this.setState({rfr : event.target.value});
        
    }

	checkInputErrors = async ()=>{
		let errors  = []
		if ( this.state.step === 1 
			&& (isNaN(this.state.pensionAlimentaire.value ) || this.state.pensionAlimentaire.value === "" )
			&& this.state.hasPensionAlimentaire
			&& !this.state.pensionDetails 
		){
			errors.push( "Veuillez saisir un montant valide pour la pension alimentaire.");
		}
		this.setState({errors: errors});
	}

	nextStep = (e)=>{
		if ( this.state.errors.length > 0){
			return false;
		}
		document.getElementById('anchor').scrollIntoView({behavior:'smooth'}) ;
		if (this.state.step+1 > this.state.steps) {
			var data = {
				"demandeur" :{
					difficultes : this.state.difficulte,
    				//permis
    				permis_de_conduire : this.state.permisDeConduire,
    				//travaux
    				travaux : this.state.travaux,
    				//achat_logement
    				achatlogement : this.state.achatLogement,
    				// changement logemnet recent
    				changementLogementRecent : this.state.changementLogementRecent,
    				//lieux solidaire
    				afficherLieuxSolidaire : this.state.lieuxSolidaire  ,
    				//creation Entreprise
    				creationEntreprise : this.state.creationEntreprise,
    				typeVelo : this.state.veloType,
    				prixVelo : this.state.veloPrice,
    				rfrParPart : this.state.rfr,
				},
				"terminer" : true,
			};

			if ( this.state.hasPensionAlimentaire  ){

				if (this.state.pensionDetails === false ){
					data.demandeur.pensions_alimentaires_versees_individu = {};
					let curMonth = new Date().getMonth();
			        let curYear = new Date().getFullYear();

			        let tarYear = curYear - 1;
			        while (curYear >= tarYear) {
			          let curDate = curYear + '-' + ('0'+(curMonth + 1)).slice(-2);
			          data.demandeur.pensions_alimentaires_versees_individu[curDate] = this.state.pensionAlimentaire.value;
			          curMonth -= 1;

			          if (curMonth < 0) {
			            curMonth = 11;
			            curYear -= 1;
			          }
			        }

				}else {
					data.demandeur.pensions_alimentaires_versees_individu = this.state.pensionAlimentaire.value;
				}
			}

			//data.demandeur.velo = { price : this.state.veloPrice , type : this.state.veloType }
			data.demandeur.typeVelo = this.state.veloType;
			data.demandeur.prixVelo = this.state.veloPrice;

			this.props.validateStep(data);
		}


		this.setState(({step})=>{
			return {step:step+1};
		});
	}

	switchRadio = (newValue,modelName)=>{
		newValue = JSON.parse(newValue);
		this.setState( ()=>{
			var newState = new Object({});
			newState[modelName] = newValue;
			return newState;
		});
	}

	switchDetails = (e) => ( this.setState(({pensionDetails})=>{ 
		pensionDetails = !pensionDetails;
		return {pensionDetails  :pensionDetails}
	}))

	capturePensionAlimentaire=(montant)=>{
		this.setState(({pensionAlimentaire})=>{
			pensionAlimentaire.value = montant;
			return {pensionAlimentaire : pensionAlimentaire};
		});
	}

	capturePensionDetailler=(montants)=>{
		this.setState( ({pensionAlimentaire,pensionDetails}) =>{
			pensionAlimentaire.value = montants;
			pensionDetails = true;
			return { pensionAlimentaire : pensionAlimentaire };
		});
	}
	//
	pensionAlimentaire =()=> {
		return <div className="pension-alimentaire">
			<div className="left-side">
				<RadioBox  name="pensionAlimentaire"
					options={{"Oui":true, "Non":false}}
					handler={this.switchRadio}
					modelName="hasPensionAlimentaire"
					defaultValue={this.state.hasPensionAlimentaire}

				><h3>Vous ou votre conjoint·e actuel·le avez-vous versé des pensions alimentaires depuis décembre 2021 ?</h3></RadioBox>
			</div>
			<div className="right-side zone-pa">
				{ (this.state.hasPensionAlimentaire) ?
					<div className="saisi-montant">
						<div  className="ressource-label">Pensions alimentaires</div> 
						{(!this.state.pensionDetails) ?
							<MontantInput name="pensionAlimentaire"
								model={this.state.pensionAlimentaire.value}
								modelName="pensionAlimentaire"
								handler={this.capturePensionAlimentaire}
							>Montant versé chaque mois</MontantInput>
						:  <MontantsDetailles name="pensionAlimentaire"
								handler= {this.capturePensionDetailler}
							></MontantsDetailles>
						}
						<small className="detail-button"
							onClick={this.switchDetails}
						>
							{(this.state.pensionDetails) ?
								'Montant fixe perçu chaque mois'
							  : 'détaillez les montants sur les 12 derniers mois'}
						</small>			
					</div>
					: ""
				}
			</div>
		</div>;
	}
	
	permisDeConduire =()=>{
		return <div className="question">
			<RadioBox 
				name="permisDeConduire"
				options={{"Oui":true ,"Non":false}}
				defaultValue={this.state.permisDeConduire}
				modelName="permisDeConduire"
				handler={this.switchRadio}
			><h3>Souhaitez-vous connaître les aides financières au permis de conduire ?</h3></RadioBox>
		</div>;
	}
	
	previous = () => {
		this.props.previousStep();
	}

	restart = ()=> {
		this.props.restart();
	}
	difficulte =()=>{
		return <div className="question">
			<RadioBox 
				name="difficulte"
				options={{"Oui":true ,"Non":false}}
				defaultValue={this.state.difficulte}
				handler={this.switchRadio}
				modelName="difficulte"
			><h3>Avez-vous d'importantes difficultés à payer les factures courantes ou les besoins de première nécessité ?</h3></RadioBox>
		</div>;
	}
	//
	achatLogement =()=>{
		return <div className="question">
			<RadioBox 
				name="achatLogement"
				options={{"Oui":true ,"Non":false}}
				defaultValue={this.state.achatLogement}
				handler={this.switchRadio}
				modelName="achatLogement"
			><h3>Souhaitez vous connaitre les aides liées à l'achat d'un logement ?</h3></RadioBox>
		</div>;
	}
	
	travaux =()=>{
		return <div className="question">
			<RadioBox 
				name="travaux"
				options={{"Oui":true ,"Non":false}}
				defaultValue={this.state.travaux}
				handler={this.switchRadio}
				modelName="travaux"
			><h3>Envisagez-vous de faire des travaux dans votre logement ?</h3></RadioBox>
		</div>;
	}
	
	changementLogementRecent =()=>{
		return <div className="question">
			<RadioBox 
				name="changementLogementRecent"
				options={{"Oui":true ,"Non":false}}
				defaultValue={this.state.changementLogementRecent}
				handler={this.switchRadio}
				modelName="changementLogementRecent"
			><h3>Avez-vous changé de logement au cours des 3 derniers mois ou envisagez-vous de déménager dans les prochains mois ?</h3></RadioBox>
		</div>;
	}
	
	lieuxSolidaire =()=>{
		return <div className="question">
			<RadioBox 
				name="permisDeConduire"
				options={{"Oui":true ,"Non":false}}
				defaultValue={false}
				modelName="lieuxSolidaire"
				handler={this.switchRadio}
			><h3>Souhaitez-vous connaître les aides financières au permis de conduire ?</h3></RadioBox>
		</div>;
	}
	
	creationEntreprise=()=>{
		return <div className="question">
			<RadioBox 
				name="creationEntreprise"
				options={{"Oui":true ,"Non":false}}
				defaultValue={this.state.creationEntreprise}
				modelName="creationEntreprise"
				handler={this.switchRadio}
			><h3>Souhaitez-vous créer ou reprendre une entreprise ?</h3></RadioBox>
		</div>;
	}
	
	aideAchatVelo =()=>{
		const infoRFR = <div>
            <h3>Comment calculer votre quotient familial :</h3>
                <p> - <strong>Consultez d’abord votre RFR :</strong> il apparaît sur la 1ère page de votre avis d'imposition dans la rubrique "vos références" sous l'appellation revenu fiscal de référence                </p>
                <p> - <strong>Ensuite, divisez le par le nombre de part</strong> qui se trouve juste en dessous de votre Revenu Fiscal de Référence sur votre avis d’imposition</p>
                <p> - <strong>Enfin, divisez le résultat obtenu par 12</strong> pour obtenir votre quotient familial</p>
            </div>;

		return <div className="question">
			<RadioBox 
				name="aideAchatVelo"
				options={{"Oui":true ,"Non":false}}
				defaultValue={this.state.aideAchatVelo}
				modelName="aideAchatVelo"
				handler={this.switchRadio}
			><h3>Souhaitez-vous connaître les aides financières pour l'achat d'un velo ?</h3></RadioBox>
			<div className={this.state.aideAchatVelo ? "visible" : "hidden"}>
				<div className = "question sub-question">
				  <h3><label>Indiquez votre Revenu Fiscal de Référence<br/> par part (quotient familial) <InfoBulle message={infoRFR}/></label></h3>
                  <input type="number" placeholder="Ex : 1000" onChange={this.updateRFR}/>
                  <span className="euroSign">€</span>
                </div>
                
				<div className = "question sub-question">
					<h3><label>Prix du velo</label></h3>
					<input type="number" placeholder="prix du velo" onChange={this.updateVeloPrice}  />
						<span className="euroSign">€</span>
				</div>
				
				<div className="question sub-question">
					<h3><label>Type de velo</label></h3>
					<select onChange={this.updateVeloType} >
				            <option value="">Choisir ...</option>
				            <option value="électrique">Electrique</option>
				            <option value="mécanique simple">Mécanique simple</option>
						    <option value="cargo" >Cargo</option>
						    <option value="cargo électrique" >Cargo Electrique</option>
						  	<option value="pliant" >Pliant</option>
						    <option value="pliant électrique" >Pliant electrique</option>
			        </select>
			    </div>
			</div>
		</div>;
	}
	//
	getQuestion () {
		var currentQuestion;
		if (this.state.step === 1){
			return this.pensionAlimentaire();
		} else if (this.state.step === 2) {
			return this.permisDeConduire();
		} else if (this.state.step === 3) {
			return this.difficulte();
		} else if (this.state.step === 4) {
			return this.travaux();
		} else if (this.state.step === 5) {
			return this.achatLogement();
		} else if (this.state.step === 6) {
			return this.changementLogementRecent();
		} else if (this.state.step === 7) {
			return this.creationEntreprise();
		} else if (this.state.step === 8) {
			return this.aideAchatVelo();
		}
	}
	render(){
		

		return <div className="step-inner-container avant-de-terminer">
			<p className="step-title"><strong>Avant de terminer</strong></p> 
			{this.getQuestion()}
			<FormError errors ={this.state.errors} />
			<button onClick={()=> ( this.checkInputErrors().then( ()=> this.nextStep())) }> Valider </button>
			<div className="button-container previous">
						<button onClick={this.restart}> Recommencer </button>
			</div>
		</div>;
	}
}

export default Questionnaire;
